import { Image } from "antd";
import { LogoBlack } from "../../assets";
import { COLORS } from "../../config/themes/colors";
import "./index.css";


export const Loading = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: COLORS.neutrals[30],
      height: "100vh",
    }}
  >
    <Image
      src={LogoBlack}
      width={400}
      preview={false}
      className="zoom-logo"
    />
  </div>
);
